import React, { useState, useEffect } from 'react';
import { updateCollectionById } from '../services/apiService';
import './EditCollectionModal.css';

const EditCollectionModal = ({ isOpen, onClose, collection, onUpdate }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isPublic, setIsPublic] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (collection) {
      setName(collection.name || '');
      setDescription(collection.description || '');
      setIsPublic(collection.isPublic || false);
    }
  }, [collection]);

  const handleSave = async () => {
    if (!name.trim()) {
      setErrorMessage('Collection name is required');
      return;
    }

    try {
      setSaving(true);
      setErrorMessage('');

      // If making public, we need to ensure consent is given
      const updateData = {
        name: name.trim(),
        description: description.trim() || null,
        isPublic: isPublic,
      };

      await updateCollectionById(collection.id, updateData);

      if (onUpdate) {
        onUpdate();
      }
      onClose();
    } catch (error) {
      console.error('Error updating collection:', error);
      setErrorMessage('Failed to update collection');
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen || !collection) return null;

  return (
    <div className="edit-collection-modal-overlay" onClick={onClose}>
      <div className="edit-collection-modal" onClick={(e) => e.stopPropagation()}>
        <button className="edit-collection-modal-close" onClick={onClose}>
          ×
        </button>

        <h2 className="edit-collection-modal-title">Edit Collection</h2>

        {errorMessage && (
          <div className="edit-collection-error">
            {errorMessage}
          </div>
        )}

        <div className="edit-collection-form">
          <div className="edit-collection-form-group">
            <label htmlFor="edit-collection-name">Name *</label>
            <input
              id="edit-collection-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter collection name"
              disabled={saving}
            />
          </div>

          <div className="edit-collection-form-group">
            <label htmlFor="edit-collection-description">Description</label>
            <textarea
              id="edit-collection-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter collection description (optional)"
              rows="3"
              disabled={saving}
            />
          </div>

          <div className="edit-collection-form-actions">
            <button
              className="edit-collection-cancel-btn"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              className="edit-collection-save-btn"
              onClick={handleSave}
              disabled={saving || !name.trim()}
            >
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCollectionModal;

